import { getHttpClient } from '../axiosInstance'

const base = '/vendor/tasks/v2'

export const fetchWithPagination = async (queryParams) => {
  const apiClient = getHttpClient()
  const url = `${base}/`
  /**
   * Add hidden parameters to make the API call
   */
  const hiddenParams = {}

  /**
   * It's also possible to remove and sanitize some parameters
   */
  const customQueryParams = { ...queryParams, ...hiddenParams }

  const response = await apiClient.get(url, { params: customQueryParams })
  return response.data
}
